import { createSelector } from 'reselect';
import { notificationSelectors } from '../../notification';

const getInitialValues = notificationId => createSelector([notificationSelectors.getById], notificationById => notificationById[notificationId] || {});

export const makeGetInitialValues = createSelector(getInitialValues, initialValues => initialValues);
